/**
 * An abstraction component that marries the theme-selection to the overpanel, to pull
 * some unnecessary logic out of the preview page. (ThemeSelection will likely only ever
 * be used in an overpanel.)
 */

import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'transfer/utils/p2p-connect'
import NewThemeSelection from '../gift-options/new-theme-selection'
import Overpanel from 'react-components/overpanel'
import { formatAmount } from 'transfer/utils/currencyUtils'
import { changeNote } from 'transfer/actions/Actions'
import { changeThemeId } from 'transfer/actions/theme'

const callAll = (...fns) => (...args) => fns.forEach(fn => fn && fn(...args))

function NewThemeSelectionOverpanel({
  handleCloseButton,
  show,
  displayName,
  formattedAmount,
  handleNextButton,
  handleChangeNote,
  note,
  thumbnailUrl,
  onSubmitTheme,
}) {
  return (
    <Overpanel show={show} handleClose={handleCloseButton}>
      <NewThemeSelection
        displayName={displayName}
        formattedAmount={formattedAmount}
        handleNextButton={callAll(
          handleNextButton,
          handleCloseButton,
          onSubmitTheme
        )}
        handleCancelButton={handleCloseButton}
        thumbnailUrl={thumbnailUrl}
        handleChangeNote={handleChangeNote}
        note={note}
      />
    </Overpanel>
  )
}

NewThemeSelectionOverpanel.propTypes = {
  handleCloseButton: PropTypes.func,
  show: PropTypes.bool,
  displayName: PropTypes.string,
  formattedAmount: PropTypes.string,
  handleChangeNote: PropTypes.func,
  note: PropTypes.string,
  thumbnailUrl: PropTypes.string,
  handleNextButton: PropTypes.func,
  onSubmitTheme: PropTypes.func,
}

export default connect(
  ({ server, amount, note }) => ({
    displayName: server.userFullName,
    formattedAmount: formatAmount(amount.amount, amount.currencyCode),
    note: note.note,
    thumbnailUrl: server.userThumbnailUrl,
  }),
  dispatch => ({
    handleChangeNote: note => dispatch(changeNote(note)),
    handleNextButton: themeId => dispatch(changeThemeId(themeId)),
  }),
  (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
  })
)(NewThemeSelectionOverpanel)
